module.exports = __webpack_public_path__ + "sounds/resources/sounds/echoed-ding-459.ed14685c17570c233f20d74162655389.mp3";